import awsLogo from '@assets/logo-aws.svg';
import React from 'react';

interface Props {}

const Aws: React.FC<Props> = () => {
  return (
    <small className="flex items-center gap-2 text-white text-sm self-end mt-auto ">
      In collaboration with <img src={awsLogo} alt="AWS" />
    </small>
  );
};

export default Aws;
